/* ============================================================
   FLOCK OF ANGELS — ASCENSION
   Master JS — Shopify theme
   ============================================================ */

(function () {
  'use strict';

  // ── Nav scroll detection + on-light detection ──────────────────────────────
  const foaNav = document.getElementById('foaNav');
  let lightBands = [];

  const refreshBands = () => {
    lightBands = Array.from(document.querySelectorAll('.light-section')).map(el => {
      const rect = el.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      return { top, bottom: top + rect.height };
    });
  };

  const noHero = !document.querySelector('.hero');

  const onScroll = () => {
    if (!foaNav) return;
    foaNav.classList.toggle('is-scrolled', noHero || window.scrollY > 40);
    const navBottom = window.scrollY + (foaNav.offsetHeight || 80) + 10;
    const onLight = noHero || lightBands.some(b => navBottom >= b.top && navBottom <= b.bottom);
    foaNav.classList.toggle('on-light', onLight);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', refreshBands);
  window.addEventListener('load', () => {
    refreshBands();
    setTimeout(refreshBands, 500);
    onScroll();
  });
  refreshBands();

  // ── Hero video: start on load / scroll ──────────────────────────────────────
  const hero = document.getElementById('hero');
  const video = document.getElementById('heroVideo');
  const ctaWrap = document.getElementById('ctaWrap');

  if (hero && video) {
    // Always reveal CTA within 200ms
    if (ctaWrap) setTimeout(() => ctaWrap.classList.add('is-revealed'), 200);

    let hasStarted = false;
    const startWings = () => {
      if (hasStarted) return;
      hasStarted = true;
      hero.classList.add('is-playing');
      video.loop = true;
      try { video.currentTime = 0; } catch (e) {}
      const p = video.play();
      if (p !== undefined) {
        p.catch(() => {
          document.addEventListener('click', () => video.play().catch(() => {}), { once: true });
        });
      }
      if (ctaWrap) setTimeout(() => ctaWrap.classList.add('is-revealed'), 800);
    };

    const onVideoReady = () => { hero.classList.add('is-ready'); startWings(); };
    if (video.readyState >= 3) {
      onVideoReady();
    } else {
      video.addEventListener('canplay', onVideoReady, { once: true });
      video.addEventListener('loadedmetadata', onVideoReady, { once: true });
    }

    window.addEventListener('wheel', startWings, { passive: true, once: true });
    window.addEventListener('touchmove', startWings, { passive: true, once: true });
    window.addEventListener('scroll', startWings, { passive: true, once: true });
    window.addEventListener('keydown', (e) => {
      if ([' ', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'End', 'Home'].includes(e.key)) startWings();
    }, { once: true });
  }

  // ── Reveal on scroll ────────────────────────────────────────────────────────
  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.reveal, .creed, .letters').forEach(el => io.observe(el));

  // ── Piece hover light tracking ───────────────────────────────────────────────
  document.querySelectorAll('.piece').forEach(el => {
    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      el.style.setProperty('--mx', ((e.clientX - rect.left) / rect.width * 100) + '%');
      el.style.setProperty('--my', ((e.clientY - rect.top) / rect.height * 100) + '%');
    });
  });

  // ── Letter reveal setup ─────────────────────────────────────────────────────
  document.querySelectorAll('.letters').forEach(el => {
    const text = el.textContent;
    el.textContent = '';
    [...text].forEach((ch, i) => {
      const span = document.createElement('span');
      span.textContent = ch === ' ' ? ' ' : ch;
      span.style.setProperty('--i', i);
      el.appendChild(span);
    });
  });

  // ── Accordion (product details) ─────────────────────────────────────────────
  document.querySelectorAll('.product-accordion').forEach(acc => {
    acc.classList.remove('is-open');
    const body = acc.querySelector('.product-accordion__body');
    if (body) body.style.height = '0';
    const btn = acc.querySelector('.product-accordion__toggle');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  });

  document.querySelectorAll('.product-accordion__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const acc = btn.closest('.product-accordion');
      const body = acc.querySelector('.product-accordion__body');
      const isOpen = acc.classList.contains('is-open');
      if (isOpen) {
        body.style.height = body.scrollHeight + 'px';
        requestAnimationFrame(() => { body.style.height = '0'; });
        acc.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        body.style.height = body.scrollHeight + 'px';
        body.addEventListener('transitionend', (e) => { if (e.propertyName === 'height' && acc.classList.contains('is-open')) body.style.height = 'auto'; }, { once: true });
        acc.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

})();

/* ============================================================
   CART (Shopify AJAX API — works natively in Shopify theme)
   ============================================================ */
(function () {
  'use strict';

  const cartBtn    = document.getElementById('foaCartBtn');
  const countEl    = document.getElementById('foaCartCount');
  const drawer     = document.getElementById('cartDrawer');
  const backdrop   = document.getElementById('cartBackdrop');
  const closeBtn   = document.getElementById('cartClose');
  const itemsEl    = document.getElementById('cartItems');
  const footerEl   = document.getElementById('cartFooter');
  const subtotalEl = document.getElementById('cartSubtotal');
  const checkoutEl = document.getElementById('cartCheckout');
  const toast      = document.getElementById('addToast');
  const toastView  = document.getElementById('addToastView');
  const errorToast = document.getElementById('cartErrorToast');
  const errorMsgEl = document.getElementById('cartErrorMsg');

  function setCount(n) {
    if (!countEl) return;
    if (n > 0) { countEl.textContent = n > 9 ? '9+' : n; countEl.style.display = 'flex'; }
    else { countEl.style.display = 'none'; }
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    if (!cart) return;
    setCount(cart.item_count || 0);
    if (!itemsEl) return;
    const lines = cart.items || [];
    if (!lines.length) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><span>✦</span><span>Your bag is empty</span></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    itemsEl.innerHTML = lines.map(ln => {
      const variant = ln.variant_title && ln.variant_title !== 'Default Title' ? ln.variant_title : '';
      const img = ln.featured_image ? ln.featured_image.url : '';
      const href = ln.url || '/products/' + ln.handle;
      return `<div class="cart-item">
        <a href="${href}" class="cart-item__img-link">${img ? `<img class="cart-item__img" src="${img}" alt="" />` : '<div class="cart-item__img"></div>'}</a>
        <div class="cart-item__info">
          <a href="${href}" class="cart-item__name">${ln.product_title}</a>
          ${variant ? `<div class="cart-item__variant">${variant}</div>` : ''}
          <div class="cart-item__price">${money(ln.price)}</div>
          <div class="cart-item__controls">
            <div class="cart-item__qty">
              <button data-key="${ln.key}" data-q="${ln.quantity}" class="q-dec">&#8722;</button>
              <span>${ln.quantity}</span>
              <button data-key="${ln.key}" data-q="${ln.quantity}" class="q-inc">+</button>
            </div>
            <button data-key="${ln.key}" class="cart-item__remove">Remove</button>
          </div>
        </div>
      </div>`;
    }).join('');

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (checkoutEl) checkoutEl.href = '/checkout';
    if (footerEl) footerEl.style.display = 'block';

    itemsEl.querySelectorAll('.q-dec').forEach(b => b.addEventListener('click', async () => {
      const q = parseInt(b.dataset.q) - 1;
      if (q <= 0) {
        const c = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) }).then(r => r.json());
        renderCart(c);
      } else {
        const c = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: q }) }).then(r => r.json());
        renderCart(c);
      }
    }));
    itemsEl.querySelectorAll('.q-inc').forEach(b => b.addEventListener('click', async () => {
      const c = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: parseInt(b.dataset.q) + 1 }) }).then(r => r.json());
      renderCart(c);
    }));
    itemsEl.querySelectorAll('.cart-item__remove').forEach(b => b.addEventListener('click', async () => {
      const c = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) }).then(r => r.json());
      renderCart(c);
    }));
  }

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (backdrop) backdrop.addEventListener('click', closeCart);

  // Toast
  let toastTimer;
  function showAddToast() {
    if (!toast) return;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4000);
  }
  if (toastView) toastView.addEventListener('click', () => { toast.classList.remove('is-visible'); openCart(); });

  // Error toast — surfaces real cart failures (e.g. "only 1 available")
  // instead of the button silently reverting with no explanation.
  let errorToastTimer;
  function showErrorToast(message) {
    if (!errorToast) return;
    if (errorMsgEl) errorMsgEl.textContent = message || 'Couldn’t add to bag';
    errorToast.classList.add('is-visible');
    clearTimeout(errorToastTimer);
    errorToastTimer = setTimeout(() => errorToast.classList.remove('is-visible'), 4000);
  }
  window.FOA = window.FOA || {};
  window.FOA.showErrorToast = showErrorToast;

  // Initial cart load
  async function initCart() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      renderCart(cart);
    } catch (e) {}
  }
  initCart();

  // Global addToCart function for sections
  window.FOA = window.FOA || {};
  window.FOA.addToCart = async function (variantId, quantity) {
    quantity = quantity || 1;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    const data = await res.json();
    if (!res.ok) {
      const raw = data.description || data.message || 'Failed to add to cart';
      // Shopify's stock/quantity-cap message is accurate but doesn't say why —
      // spell out that they already grabbed the last unit in stock.
      const friendly = /maximum quantity/i.test(raw)
        ? 'You already added the last one available — it’s in your bag.'
        : raw;
      throw new Error(friendly);
    }
    const cartFull = await fetch('/cart.js').then(r => r.json());
    renderCart(cartFull);
    showAddToast();
    return cartFull;
  };

  window.FOA.openCart = openCart;
  window.FOA.closeCart = closeCart;

})();

/* ============================================================
   FOA SIDE MENU + SEARCH
   ============================================================ */
(function () {
  'use strict';

  const menuBtn      = document.getElementById('foaMenuBtn');
  const menu         = document.getElementById('foaMenu');
  const menuClose    = document.getElementById('foaMenuClose');
  const menuBackdrop = document.getElementById('foaMenuBackdrop');
  const catalogBtn   = document.getElementById('foaCatalogBtn');
  const readyToWearBtn = document.getElementById('foaReadyToWearBtn');
  const accessoriesBtn = document.getElementById('foaAccessoriesBtn');
  const menuL2       = document.getElementById('foaMenuL2');
  const menuL3       = document.getElementById('foaMenuL3');
  const menuL3Acc    = document.getElementById('foaMenuL3Accessories');
  const menuSearchBtn= document.getElementById('foaMenuSearchBtn');
  const searchOverlay= document.getElementById('foaSearch');
  const searchClose  = document.getElementById('foaSearchClose');
  const searchInput  = document.getElementById('foaSearchInput');
  const searchBody   = document.getElementById('foaSearchBody');
  const l2Back       = document.getElementById('foaMenuL2Back');
  const l3Back       = document.getElementById('foaMenuL3Back');
  const l3BackAcc    = document.getElementById('foaMenuL3BackAcc');
  const l2Close      = document.getElementById('foaMenuL2Close');
  const l3Close      = document.getElementById('foaMenuL3Close');
  const l3CloseAcc   = document.getElementById('foaMenuL3CloseAcc');

  function openMenu() {
    if (!menu) return;
    menu.classList.add('is-open');
    if (menuBackdrop) menuBackdrop.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    if (menuBackdrop) menuBackdrop.classList.remove('is-open');
    if (menuL2) menuL2.classList.remove('is-open');
    if (menuL3) menuL3.classList.remove('is-open');
    if (menuL3Acc) menuL3Acc.classList.remove('is-open');
    if (catalogBtn) catalogBtn.classList.remove('is-active');
    if (readyToWearBtn) readyToWearBtn.classList.remove('is-active');
    if (accessoriesBtn) accessoriesBtn.classList.remove('is-active');
    menu.setAttribute('aria-hidden', 'true');
    if (!(searchOverlay && searchOverlay.classList.contains('is-open'))) document.body.style.overflow = '';
  }

  if (menuBtn) menuBtn.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuBackdrop) menuBackdrop.addEventListener('click', closeMenu);
  if (menu) menu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));

  if (catalogBtn) catalogBtn.addEventListener('click', () => {
    const o = menuL2 && menuL2.classList.toggle('is-open');
    catalogBtn.classList.toggle('is-active', !!o);
    if (!o) {
      if (menuL3) menuL3.classList.remove('is-open');
      if (menuL3Acc) menuL3Acc.classList.remove('is-open');
      if (readyToWearBtn) readyToWearBtn.classList.remove('is-active');
      if (accessoriesBtn) accessoriesBtn.classList.remove('is-active');
    }
  });
  if (readyToWearBtn) readyToWearBtn.addEventListener('click', () => {
    const o = menuL3 && menuL3.classList.toggle('is-open');
    readyToWearBtn.classList.toggle('is-active', !!o);
    if (o && menuL3Acc) menuL3Acc.classList.remove('is-open');
    if (o && accessoriesBtn) accessoriesBtn.classList.remove('is-active');
  });
  if (accessoriesBtn) accessoriesBtn.addEventListener('click', () => {
    const o = menuL3Acc && menuL3Acc.classList.toggle('is-open');
    accessoriesBtn.classList.toggle('is-active', !!o);
    if (o && menuL3) menuL3.classList.remove('is-open');
    if (o && readyToWearBtn) readyToWearBtn.classList.remove('is-active');
  });

  if (l2Back) l2Back.addEventListener('click', () => {
    if (menuL2) menuL2.classList.remove('is-open');
    if (catalogBtn) catalogBtn.classList.remove('is-active');
    if (menuL3) menuL3.classList.remove('is-open');
    if (menuL3Acc) menuL3Acc.classList.remove('is-open');
    if (readyToWearBtn) readyToWearBtn.classList.remove('is-active');
    if (accessoriesBtn) accessoriesBtn.classList.remove('is-active');
  });
  if (l3Back) l3Back.addEventListener('click', () => {
    if (menuL3) menuL3.classList.remove('is-open');
    if (readyToWearBtn) readyToWearBtn.classList.remove('is-active');
  });
  if (l3BackAcc) l3BackAcc.addEventListener('click', () => {
    if (menuL3Acc) menuL3Acc.classList.remove('is-open');
    if (accessoriesBtn) accessoriesBtn.classList.remove('is-active');
  });
  if (l2Close) l2Close.addEventListener('click', closeMenu);
  if (l3Close) l3Close.addEventListener('click', closeMenu);
  if (l3CloseAcc) l3CloseAcc.addEventListener('click', closeMenu);

  // Static browse links — shown when search is empty (mirrors original HTML)
  const quickBrowseHTML = '<div class="foa-search__section-label">Browse</div><ul class="foa-search__quick-list"><li><a href="/collections/ready-to-wear">Ready to Wear</a></li><li><a href="/collections/hats">Accessories &mdash; Hats</a></li></ul>';

  // Search
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => { if (searchInput) searchInput.focus(); }, 60);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    if (!(menu && menu.classList.contains('is-open'))) document.body.style.overflow = '';
  }
  if (menuSearchBtn) menuSearchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  // Live search via Shopify Predictive Search API
  let searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (!q) {
        if (searchBody) searchBody.innerHTML = quickBrowseHTML;
        return;
      }
      searchTimer = setTimeout(async () => {
        if (!searchBody) return;
        searchBody.innerHTML = '<div class="foa-search__status">Searching&hellip;</div>';
        try {
          const data = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`).then(r => r.json());
          const products = data.resources?.results?.products || [];
          if (!products.length) {
            searchBody.innerHTML = '<div class="foa-search__status">No results found.</div>';
            return;
          }
          searchBody.innerHTML = products.map(p => `
            <a href="${p.url}" class="foa-search__result" onclick="window.FOA&&window.FOA.closeSearch&&window.FOA.closeSearch()">
              ${p.featured_image?.url ? `<img class="foa-search__result-img" src="${p.featured_image.url}" alt="" />` : ''}
              <div>
                <div class="foa-search__result-name">${p.title}</div>
                <div class="foa-search__result-price">${p.price ? '$' + (parseInt(p.price) / 100).toFixed(0) : ''}</div>
              </div>
            </a>`).join('');
        } catch (e) {
          searchBody.innerHTML = '';
        }
      }, 300);
    });
  }

  // Expose closeSearch globally for search result click handlers
  window.FOA = window.FOA || {};
  window.FOA.closeSearch = closeSearch;

})();

/* ============================================================
   PRODUCT PAGE — Gallery carousel, size selection, ATC
   ============================================================ */
(function () {
  'use strict';

  const gallery     = document.querySelector('.product-gallery__main');
  const track       = document.querySelector('.product-gallery__track');
  const thumbs      = document.querySelectorAll('.product-gallery__thumb');
  const dotsWrap    = document.querySelector('.product-gallery__dots');
  const sizeBtns    = document.querySelectorAll('.product-size-btn');
  const atcBtn      = document.getElementById('productAtc');
  const mobileAtcBtn= document.getElementById('mobileAtcBtn');
  const sizeSheet   = document.getElementById('sizeSheet');
  const sizeSheetBd = document.getElementById('sizeSheetBd');
  const sizeSheetClose = document.getElementById('sizeSheetClose');
  const sheetAtcBtn = document.getElementById('sheetAtcBtn');

  if (!track) return; // Not on product page

  let currentSlide = 0;
  const slides = track.querySelectorAll('.product-gallery__slide');
  const totalSlides = slides.length;

  // Build dots
  if (dotsWrap && totalSlides > 1) {
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'product-gallery__dot' + (i === 0 ? ' is-active' : '');
      dot.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(dot);
    });
  }

  function goTo(idx) {
    currentSlide = Math.max(0, Math.min(idx, totalSlides - 1));
    track.style.transform = `translateX(-${currentSlide * 100}%)`;
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === currentSlide));
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.product-gallery__dot').forEach((d, i) => d.classList.toggle('is-active', i === currentSlide));
    }
  }

  thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));

  // Touch swipe
  if (gallery) {
    let startX = 0;
    gallery.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(currentSlide + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  // Size selection — products with only one variant have no size pills to
  // pick, so the current (only) variant is already the selection. Products
  // with real size options require an explicit pill click before ATC works.
  const requiresSize = !!(atcBtn && atcBtn.dataset.requiresSize !== 'false');
  let selectedVariantId = requiresSize ? null : (atcBtn.dataset.variantId || null);
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-oos')) return;
      if (btn.disabled) return;
      sizeBtns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      selectedVariantId = btn.dataset.variantId || null;
    });
  });

  // After each successful add, drop the size selection so the buttons go
  // back to prompting "Select Size" for the next size/quantity instead of
  // silently re-adding whatever was last picked.
  function resetSizeSelection() {
    if (!requiresSize) return;
    selectedVariantId = null;
    sizeBtns.forEach(b => b.classList.remove('selected'));
    document.querySelectorAll('.size-sheet__item').forEach(b => b.classList.remove('is-selected'));
    const sheetFooter = document.getElementById('sizeSheetFooter');
    if (sheetFooter) sheetFooter.style.display = 'none';
  }

  // ATC
  async function handleATC() {
    if (!selectedVariantId) {
      // On mobile, open size sheet
      if (sizeSheet) {
        sizeSheet.classList.add('is-open');
        if (sizeSheetBd) sizeSheetBd.classList.add('is-open');
      }
      return;
    }
    // Only disable buttons for the actual network round trip — once it
    // settles, re-enable immediately so a second add (more qty, a different
    // size) isn't blocked by the "Added!" cooldown that follows.
    if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }
    if (mobileAtcBtn) { mobileAtcBtn.disabled = true; mobileAtcBtn.textContent = 'Adding…'; }
    if (sheetAtcBtn) { sheetAtcBtn.disabled = true; sheetAtcBtn.textContent = 'Adding…'; }
    const sheetWasOpen = !!(sizeSheet && sizeSheet.classList.contains('is-open'));
    try {
      await window.FOA.addToCart(selectedVariantId);
      if (atcBtn) { atcBtn.disabled = false; atcBtn.classList.add('success'); atcBtn.textContent = 'Added!'; }
      if (mobileAtcBtn) { mobileAtcBtn.disabled = false; mobileAtcBtn.classList.add('success'); mobileAtcBtn.textContent = 'Added!'; }
      if (sheetAtcBtn) { sheetAtcBtn.disabled = false; sheetAtcBtn.classList.add('success'); sheetAtcBtn.textContent = 'Added!'; }
      // Close the size sheet promptly once the item's added
      if (sheetWasOpen) {
        setTimeout(() => {
          sizeSheet.classList.remove('is-open');
          if (sizeSheetBd) sizeSheetBd.classList.remove('is-open');
        }, 400);
      }
      setTimeout(() => {
        resetSizeSelection();
        const label = requiresSize ? 'Select Size' : 'Add to Cart';
        if (atcBtn) { atcBtn.classList.remove('success'); atcBtn.textContent = label; }
        if (mobileAtcBtn) { mobileAtcBtn.classList.remove('success'); mobileAtcBtn.textContent = label; }
        if (sheetAtcBtn) { sheetAtcBtn.classList.remove('success'); sheetAtcBtn.textContent = label; }
      }, 1200);
    } catch (e) {
      if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
      if (mobileAtcBtn) { mobileAtcBtn.disabled = false; mobileAtcBtn.textContent = 'Add to Cart'; }
      if (sheetAtcBtn) { sheetAtcBtn.disabled = false; sheetAtcBtn.textContent = 'Add to Cart'; }
      if (window.FOA && window.FOA.showErrorToast) window.FOA.showErrorToast(e && e.message);
    }
  }

  if (atcBtn) atcBtn.addEventListener('click', handleATC);
  if (mobileAtcBtn) mobileAtcBtn.addEventListener('click', handleATC);
  if (sheetAtcBtn) sheetAtcBtn.addEventListener('click', handleATC);

  // Size sheet
  if (sizeSheetClose) sizeSheetClose.addEventListener('click', () => {
    if (sizeSheet) sizeSheet.classList.remove('is-open');
    if (sizeSheetBd) sizeSheetBd.classList.remove('is-open');
  });
  if (sizeSheetBd) sizeSheetBd.addEventListener('click', () => {
    if (sizeSheet) sizeSheet.classList.remove('is-open');
    sizeSheetBd.classList.remove('is-open');
  });

})();

/* ============================================================
   NEWSLETTER FORM
   ============================================================ */
(function () {
  'use strict';

  const toast = document.getElementById('newsletterToast');
  let toastTimer = null;
  let toastScroll = null;

  function showToast() {
    clearTimeout(toastTimer);
    if (toastScroll) { window.removeEventListener('scroll', toastScroll); toastScroll = null; }
    if (!toast) return;
    toast.classList.add('is-visible');
    toastTimer = setTimeout(hideToast, 1500);
    toastScroll = function () { hideToast(); };
    window.addEventListener('scroll', toastScroll, { once: true, passive: true });
  }

  function hideToast() {
    clearTimeout(toastTimer);
    toastTimer = null;
    if (toastScroll) { window.removeEventListener('scroll', toastScroll); toastScroll = null; }
    if (toast) toast.classList.remove('is-visible');
  }

  // ── newsletter-community form (two-checkbox validation, matches original HTML) ──
  const newsletterSubmit = document.getElementById('newsletterSubmit');
  if (newsletterSubmit) {
    function clearErrOnChange(errEl, chkEl) {
      chkEl.addEventListener('change', function () {
        if (chkEl.checked) errEl.classList.remove('is-visible');
      }, { once: true });
    }

    newsletterSubmit.addEventListener('click', function () {
      const emailInput = document.getElementById('newsletterEmail');
      const chk1       = document.getElementById('newsletterCheck1');
      const chk2       = document.getElementById('newsletterCheck2');
      const err1       = document.getElementById('newsletterError1');
      const err2       = document.getElementById('newsletterError2');
      let valid = true;

      if (!emailInput || !emailInput.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) {
        if (emailInput) emailInput.focus();
        valid = false;
      }
      if (chk1 && !chk1.checked) {
        if (err1) { err1.classList.add('is-visible'); clearErrOnChange(err1, chk1); }
        valid = false;
      }
      if (chk2 && !chk2.checked) {
        if (err2) { err2.classList.add('is-visible'); clearErrOnChange(err2, chk2); }
        valid = false;
      }
      if (!valid) return;

      showToast();
    });
  }

})();
